import { Box, Button, Heading, Text, Image } from '../../../../../mads';
import { useI18n } from '../../../../../shared/I18n';
import { navigateView } from '../../../../native-module/navigateView';
import { useCloseVJ } from '../../../lib/useCloseVJ';

import { colors } from '@indeed/ifl-tokens';
import { useCallback } from 'react';
import { StyleSheet } from 'react-native';

interface Props {
    url: string | null;
}

export const NotFoundErrorPage = (props: Props) => {
    const { url } = props;

    const { gettext } = useI18n();
    const closeVJ = useCloseVJ();
    const navigateToSupportPage = useCallback(async () => {
        await navigateView(
            url ?? '',
            // this page doesn't have qa version!
            'https://support.indeed.com/hc',
            '',
            '',
        );
    }, [url]);

    return (
        <Box sx={styles.container}>
            {}
            {/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment */}
            <Image style={styles.image} source={require('./404.png')} accessible={false} />
            <Heading sx={styles.heading}>{gettext("We can't find this page")}</Heading>
            <Text level={3} sx={styles.description}>
                {gettext(
                    "It looks like this page doesn't exist or isn't available right now. Check the URL for any typos or choose an option below.",
                )}
            </Text>
            <Button size="lg" onPress={closeVJ}>
                {gettext('Go back')}
            </Button>
            <Box sx={styles.contactContainer}>
                <Text level={3} sx={styles.needHelp}>
                    {gettext('Need more help?')}
                </Text>
                {/* eslint-disable-next-line @typescript-eslint/no-misused-promises -- FIXME */}
                <Button variant="text" onPress={navigateToSupportPage}>
                    <Text level={3} sx={styles.contactUs}>
                        {gettext('Contact us')}
                    </Text>
                </Button>
            </Box>
        </Box>
    );
};

const styles = StyleSheet.create({
    container: {
        margin: 16,
    },
    image: {
        alignSelf: 'center',
    },
    heading: {
        textAlign: 'center',
        marginTop: 16,
        marginBottom: 16,
        alignSelf: 'center',
    },
    description: { textAlign: 'left', marginBottom: 32 },
    button: {
        flexBasis: 'auto',
    },
    contactContainer: {
        flexDirection: 'row',
        justifyContent: 'center',
    },
    needHelp: {
        alignSelf: 'center',
    },
    contactUs: {
        color: colors.primary[800],
        textDecorationLine: 'underline',
        fontWeight: 'normal',
    },
});
